import styles from "./ReferralBarForHeader.module.scss";
import Button from "@Components/Button";
import Image from "@Components/Image";
import { BASE_IMG_URL } from "constants/configConstants";
import LoginDispatcher from "@Components/Login/actions";
import { useDispatch, useSelector } from "react-redux";
import { AppState } from "@Store/index";
import wrapperHOC from "@Utils/wrapperHOC";
import gtagEventEmitter from "helpers/gtagEventEmitter";
import useTranslationHook from "hooks/useTranslationHook";

const ReferralBarForHeader = () => {
  const dispatch = useDispatch();
  const { t } = useTranslationHook();
  const loginDispatcher = new LoginDispatcher(dispatch);
  const toggleLoginModal = () => {
    loginDispatcher.showLoginModal({ openingSource: "referral_programme" });
    gtagEventEmitter({
      action: "clicked_get_referral_link_navbar",
      category: "referral_page",
    });
  };
  const { isUserLoggedIn } = useSelector(({ appData }: AppState) => ({
    isUserLoggedIn: appData.isUserLoggedIn,
  }));
  return (
    <>
      {!isUserLoggedIn ? (
        <div className={styles.parentContainerForReferralBar}>
          <div className={styles.leftContainerForReferralBar}>
            <div className={styles.iconReferralBar}>
              <Image
                src={`${BASE_IMG_URL}/booking-step-3-new.svg`}
                alt="Refer-And-Earn-Icon"
                width="32"
                height="32"
              />
            </div>
            <div className={styles.titleReferralBar}>
              {t("home.components.referralbarforheader.title")}
            </div>
          </div>
          <Button variant="none" className={styles.getReferralLinkCTA} onClick={toggleLoginModal}>
            {t("home.components.referralbarforheader.getreferrallink")}
          </Button>
        </div>
      ) : (
        <></>
      )}
    </>
  );
};

export default wrapperHOC(ReferralBarForHeader, {
  componentName: "Global-ReferralBarForHeader",
  showForChina: true,
});
